module.exports = __webpack_public_path__ + "img/08f6373.png";